/**
 * Vincent bug #94 (2026-05-08) — Bouton « Back » universel.
 * À placer en haut-gauche de toutes les pages non accessibles depuis le menu de gauche.
 * Utilise le hook useNavBack (qui maintient une stack d'historique IN-APP en sessionStorage)
 * pour retourner à la page précédente sans casser sur les navigations externes.
 *
 * Usage: <BackButton /> en haut du JSX de la page, ou <BackButton fallback="/dashboard/admin" />
 * pour spécifier une page de secours quand l'historique est vide.
 */
import { useNavBack } from "../hooks/useNavBack";
import { CaretLeft } from "@phosphor-icons/react";
import { useLang } from "../contexts/LanguageContext";

export default function BackButton({ fallback = "/dashboard", className = "" }) {
  const goBack = useNavBack(fallback);
  const { lang } = useLang();
  return (
    <button
      onClick={goBack}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-zinc-200 bg-white hover:bg-zinc-50 text-zinc-700 text-xs font-medium transition-colors ${className}`}
      data-testid="page-back-btn"
      aria-label={lang === "fr" ? "Retour" : "Back"}
    >
      <CaretLeft size={14} weight="bold" />
      {lang === "fr" ? "Retour" : "Back"}
    </button>
  );
}
